import { render, staticRenderFns } from "./ProductItemComponent.vue?vue&type=template&id=b7409f56&"
import script from "./ProductItemComponent.vue?vue&type=script&lang=js&"
export * from "./ProductItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports